import { Badge } from "./Badge";

const ActiveBadge = ({ booleanValue }) => {
  return (
    <Badge variant={booleanValue ? "outline" : "secondary"}>
      {booleanValue ? "Activo" : "Inactivo"}
    </Badge>
  );
};

export default ActiveBadge;
